import store from '../../store'
import router from '../../router'

export default function errorResponseHandler(error) {
    if (error.status === 401) {
        store.dispatch('logout')
        router.push({ path: '/login' })
    }
    return error
}